import mutations from './mutations';
import { DataService } from '../../../../config/dataService/dataService';

const state = () => ({
    loading: false,
    error: null,
    validationMessage: '',
    validationTitle: 'Email verification error',
});

const actions = {
    async readByToken({ commit }, token) {
        state.loading = true;
        await DataService.get(`/verify-account/${token}`).then((response) => {
            commit('confirmEmailSuccess', response.data.message);
        }).catch((err) => {
           commit('confirmEmailErr', err.message);
        });
    },
};

export default {
    namespaced: false,
    state,
    actions,
    mutations,
};